import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useState, useEffect } from "react";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Divider,
  Button,
  CircularProgress,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@material-ui/core";
// import AuditTable from "./AuditTable";
import AuditReportTableNew from "./AuditReportTableNew";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";

const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: //"Created"
      color = "#B4B4B4";
      break;
    case 23: //"Under confirmation":
      color = "#E78A00";
      break;
    case 22: //"Shared with CMO":
      color = "#2196F3";
      break;
    case 25: //"Confirmed":
      color = "#329429";
      break;
    case 29: //"Under Revision":
      color = "#329429";
      break;
    case 31: //"Revised":
      color = "#329429";
      break;
    case 30: //"Delivery Complete":
      color = "#707070";
      break;
    case 27: //"Approved":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 24: //"Rejected By CMO":
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};


const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "2rem",
    padding: theme.spacing(1),
    fontFamily: "sans-serif",
  },
  backContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
  auditReportText: {
    // transform: "translateX(-50%)",
    fontFamily: "sans-serif",
    fontSize: "1.5rem",
  },
  table: {
    minWidth: 650,
  },
  horizontalBox: {
    boxSizing: "border-box",
    width: "100%",
    borderBottom: "1px solid #ccc",
    backgroundColor: "#f2f8fb", // Light blue background color
    minHeight: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    gap: "1rem",
    padding: "8px 16px",
    borderRadius: "8px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  statusChip: {
    padding: "4px 16px",
    color: "#fff",
    borderRadius: "4px",
  },
  linkButton: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    textTransform: "none",
  },

  orangeButton: {
    backgroundColor: "#ec6535", // Orange background color
    color: "#fff",
    padding: "6px 16px",
    borderRadius: "20px",
    // fontWeight: "bold",
    textTransform: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    height: "fit-content",
    alignSelf: "center",
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },

  block: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "1rem",
  },
  errorText: {
    display: "block",
    width: "100%",
    fontSize: "14px",
    marginTop: "4px",
    padding: "1em",
    backgroundColor: "#f8d7da",
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
    height: "80dvh",
  },
  clickableTextSty: {
    // maxWidth: "250px",
    "&:hover": {
      textDecoration: "underline",
      color: "#2196F3",
      cursor: "pointer",
    },
  },
}));



export default function AuditReportNew({ rowInfo, setOpenPoHistory, poLineAuditsNewData,
  poLineAuditsNewDataLoading, }) {
  const classes = useStyles();
  const [poData, setPoData] = useState(null);
  const [selectedLine, setSelectedLine] = useState("all");
  const [auditTrailData, setAuditTrailData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(false); //table error
  const [pageError, setPageError] = useState(false); //table error
  const location = useLocation();

  console.log("rowInfo", rowInfo);

  // const SLDetailsData = location.state?.data;
  // const schrockenSAID = SLDetailsData?.schrockenSAID || 27753;
  // useEffect(() => {
  //   setPageLoading(true);
  //   setPageError(false);
  //   const fetchPOData = () => {
  //     axios
  //       .post(
  //         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOAuditDetails`,
  //         { schrockenSAID }
  //       )
  //       .then((res) => {
  //         if (res.data.status) {
  //           setPoData(res.data.data);
  //           setPageLoading(false);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("Error fetching data", err);
  //         setPageLoading(false);
  //         setPageError(true);
  //       });
  //   };

  //   fetchPOData();
  //   fetchAllPOLines();
  //   // setPoData(poHistoryData);
  //   // setSelectedLine(poHistoryData.poLineItemsList[0].schrockenSLID);
  // }, [schrockenSAID]);

  // const handleLineChange = (event) => {
  //   setSelectedLine(event.target.value);
  // };
  // const handleViewReport = () => {
  //   setTableLoading(true);
  //   setError(false);

  //   if (selectedLine === "none") {
  //     setAuditTrailData([]);
  //     setTableLoading(false);
  //     return;
  //   }

  //   if (selectedLine === "all") {
  //     //call api for all lines
  //     fetchAllPOLines();
  //     return;
  //   }

  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineAuditDetails/`,
  //       { schrockenSLID: selectedLine }
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         setAuditTrailData(res.data.data.poLineAuditTrail);
  //         setTableLoading(false);
  //       } else {
  //         console.log("Error fetching audit trail data:", res.data.message);
  //         setTableLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Error fetching audit trail data", err);
  //       setTableLoading(false);
  //       setError(true);
  //     });
  // };

  // function fetchAllPOLines() {
  //   axios
  //     .post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOAllLinesAuditDetails`,
  //       { schrockenSAID }
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         setAuditTrailData(res.data.data.poLineAuditTrail);
  //         setTableLoading(false);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("Error fetching data", err);
  //       setTableLoading(false);
  //       setError(true);
  //     });
  // }
  // Function to handle the "Back" button click event
  const handleBack = () => {
    setOpenPoHistory(false)
  };
  // Function to determine the background color based on poStatus
  // const getStatusColor = (status) => {
  //   switch (status) {
  //     case "Created":
  //       return "#B4B4B4";

  //     case "Under confirmation":
  //       return "#E78A00";

  //     case "Shared with CMO":
  //       return "#2196F3";

  //     case "Confirmed":
  //       return "#707070";

  //     case "Approved":
  //       return "#329429";

  //     case "Rejected By CMO":
  //       return "#FF0000";

  //     case "Closed":
  //       return "#1E1E1E";
  //     default:
  //       return "#ccc"; // Default color if status is unknown
  //   }
  // };
  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const months = [
  //     "JAN",
  //     "FEB",
  //     "MAR",
  //     "APR",
  //     "MAY",
  //     "JUN",
  //     "JUL",
  //     "AUG",
  //     "SEP",
  //     "OCT",
  //     "NOV",
  //     "DEC",
  //   ];

  //   const day = date.getDate().toString().padStart(2, "0");
  //   const month = months[date.getMonth()];
  //   const year = date.getFullYear();

  //   return `${day}-${month}-${year}`;
  // };

  return (
    <div>
      <nav className={classes.title}>
        <div className={classes.backContainer} onClick={handleBack}>
          <ChevronLeftIcon fontSize="12" aria-label="Go back" />
          <p style={{ marginLeft: "8px", fontWeight: 'bold' }}>Back</p>
        </div>
        <div className={classes.auditReportText}>
          <h3>Audit Report</h3>
        </div>
        <div style={{ width: "4rem" }}></div>
      </nav>

      <TableContainer component={Paper} style={{ backgroundColor: "#f2f8fb" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{fontWeight: 'bold' }}>{localStorage.collabType === "CMO" ? "SO Number" : "PO Number"}</TableCell>
              <TableCell style={{fontWeight: 'bold' }}>Product Code / Description</TableCell>
              <TableCell style={{fontWeight: 'bold' }}>CMO</TableCell>
              <TableCell style={{fontWeight: 'bold' }}>Date of Creation</TableCell>
              <TableCell style={{fontWeight: 'bold' }}>Created By</TableCell>
              <TableCell align="center" style={{fontWeight: 'bold' }}>{localStorage.collabType === "CMO" ? "SO Status" : "PO Status"}</TableCell>
              {/* <TableCell>PO PDF</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowInfo?.scheduleLineDetails && (
              <TableRow>
                {/* PO Number */}
                <TableCell>
                  {localStorage.collabType === "CMO" ? rowInfo?.scheduleLineDetails?.cmoSalesOrderNumber ||
                    "NA" : rowInfo?.scheduleLineDetails?.scheduleAgreementNumber ||
                    "NA"}
                </TableCell>

                {/* Product Code / Description */}
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.fgMaterialCode || "NA"} /{" "}
                  <br />
                  {rowInfo?.scheduleLineDetails?.fgMaterialName || "NA"}
                </TableCell>

                {/* CMO/CDMO */}
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.vendorName || "NA"}
                </TableCell>
                {/* Date of Creation */}
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.creationDate
                    ? moment(rowInfo.scheduleLineDetails.creationDate).format("DD-MMM-YYYY").toUpperCase()
                    : "NA"}
                </TableCell>

                {/* created by */}
                <TableCell>
                  {rowInfo?.scheduleLineDetails?.userName || "NA"}
                </TableCell>

                {/* Status */}
                <TableCell align="center">
                  <Box
                    style={{
                      // backgroundColor: rowInfo.scheduleLineDetails.scheduleLineStatusText === "Created" ? "blue" : "green",
                      color: "#fff",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      display: "inline-block",
                    }}
                  >
                    {/* {rowInfo.scheduleLineDetails.scheduleLineStatusText || "N/A"} */}
                    {renderPOStatusButton(
                      rowInfo?.scheduleLineDetails?.scheduleLineStatusID,
                      rowInfo?.scheduleLineDetails?.scheduleLineStatusText
                    )}
                  </Box>
                </TableCell>

                {/* <TableCell>
                  <Typography
                    variant="body1"
                    style={{ fontWeight: 550, textDecoration: "underline" }}
                    className={classes.clickableTextSty}
                  >
                    Click here to download
                  </Typography>
                </TableCell> */}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <AuditReportTableNew
        poLineAuditsNewData={poLineAuditsNewData}
        poLineAuditsNewDataLoading={poLineAuditsNewDataLoading}
        rowInfo={rowInfo}
      />
    </div>
  );
}
